
































import { Component, Prop, Vue } from "vue-property-decorator";
import { KatalogItem } from "@/constants/geriatriOptions";

@Component
export default class CheckboxGroupSlug extends Vue {
  @Prop({ default: () => ({}) }) readonly target!: Record<string, any>;
  @Prop({ type: String, default: "temuan" }) readonly arrayKey!: string;
  @Prop({ default: () => [] }) readonly items!: KatalogItem[];
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
  @Prop({ type: [String, Number], default: 6 }) readonly sm!: string | number;
  @Prop({ type: [String, Number], default: 4 }) readonly md!: string | number;
  @Prop({ type: String, default: "" }) readonly catatanKey!: string;
  @Prop({ type: String, default: "Catatan" }) readonly catatanLabel!: string;
  @Prop({ type: [String, Number], default: undefined }) readonly catatanMaxlength!: string | number | undefined;

  get daftar(): string[] {
    const nilai = this.target[this.arrayKey];
    return Array.isArray(nilai) ? nilai : [];
  }

  terpilih(slug: string): boolean {
    return this.daftar.indexOf(slug) !== -1;
  }

  toggle(slug: string, aktif: boolean) {
    const berikutnya = aktif
      ? this.daftar.concat([slug])
      : this.daftar.filter(s => s !== slug);
    this.$set(this.target, this.arrayKey, berikutnya);
    this.$emit("change");
  }

  setCatatan(nilai: string) {
    this.$set(this.target, this.catatanKey, nilai);
    this.$emit("change");
  }
}
